(function() {
  function initTimer(timerEl) {
    const sectionId = timerEl.dataset.sectionId;
    const endKey = timerEl.dataset.endKey;
    const hrsEl = document.getElementById(`hrs-${sectionId}`);
    const minEl = document.getElementById(`min-${sectionId}`);
    const secEl = document.getElementById(`sec-${sectionId}`);
    if (!hrsEl || !minEl || !secEl) return;
    let endTime = localStorage.getItem(endKey);
    const now = Date.now();
    const midnight = new Date();
    midnight.setHours(24, 0, 0, 0);
    if (!endTime || now > parseInt(endTime, 10)) {
      endTime = midnight.getTime();
      localStorage.setItem(endKey, endTime);
    } else {
      endTime = parseInt(endTime, 10);
    }
    function update() {
      let diff = endTime - Date.now();
      if (diff <= 0) {
        const newMidnight = new Date();
        newMidnight.setHours(24, 0, 0, 0);
        endTime = newMidnight.getTime();
        localStorage.setItem(endKey, endTime);
        diff = endTime - Date.now();
      }
      const hrs = Math.floor(diff / 3600000);
      const min = Math.floor((diff % 3600000) / 60000);
      const sec = Math.floor((diff % 60000) / 1000);

      hrsEl.textContent = String(hrs).padStart(2, "0");
      minEl.textContent = String(min).padStart(2, "0");
      secEl.textContent = String(sec).padStart(2, "0");
    }
    update();
    setInterval(update, 1000);
  }
  document.querySelectorAll(".u-timer").forEach(initTimer);
})();

function initializeReviewsSwiper() {
  var swiper = new Swiper(".reviews-umySwiper", {
    spaceBetween: 15,
    slidesPerView: 3,
    speed: 400,
    loop:true,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    breakpoints: {
      348: {
        slidesPerView: 1.3,
        spaceBetween: 15,
      },
      640: {
        slidesPerView: 2,
        spaceBetween: 15,
      },
      768: {
        slidesPerView: 3,
        spaceBetween: 10,
      },
      1024: {
        slidesPerView: 3,
        spaceBetween: 15,
      }
    }
  });
}
function initLuminDifferentSlider() {
  if (window.innerWidth > 768) return;
  const slider = document.querySelector('.u-lumin-different-slider');
  if (!slider) return;
  if (slider.classList.contains('swiper-initialized')) return;
  new Swiper(slider, {
    slidesPerView: 1,
    spaceBetween: 16,
    loop: false,
    navigation: {
      nextEl: '.u-lumin-next',
      prevEl: '.u-lumin-prev',
    },
    pagination: {
      el: '.u-lumin-pagination',
      clickable: true,
      type: 'bullets',
    },
    breakpoints: {
      480: {
        slidesPerView: 1,
      },
      640: {
        slidesPerView: 1,
      },
    },
  });
}

function initReviewSlidertp() {
  const slider = document.querySelector('.u-review-slider');
  if (!slider) return;
  if (slider.classList.contains('swiper-initialized')) return;

  new Swiper(slider, {
    loop: false,
    navigation: {
      nextEl: '.u-review-simple-next',
      prevEl: '.u-review-simple-prev',
    },
    pagination: {
      el: '.u-review-simple-pagination',
      clickable: true,
      type: 'bullets',
    },
    spaceBetween: 20,
    slidesPerView: 3,
    breakpoints: {
      0: {
        slidesPerView: 1,
      },
      768: {
        slidesPerView: 2,
      },
      1024: {
        slidesPerView: 3,
      },
    },
  });
}


  function initSimpleSlider() {
    document.querySelectorAll('.mysimpleReviewSwiper').forEach((slider) => {
      if (slider.swiper) return;
      new Swiper(slider, {
        slidesPerView: 1,
        spaceBetween: 30,
        loop: true,
        navigation: {
          nextEl: '.u-simple-swiper-button-next',
          prevEl: '.u-simple-swiper-button-prev',
        },
        pagination: {
          el: '.u-simple-imag-slider-pagina',
          clickable: true,
        },
        autoplay: {
          delay: 3000,
          disableOnInteraction: false,
        },

        breakpoints: {
          768: {
            slidesPerView: 2,
          },
          1000: {
            slidesPerView: 4,
          },
        },
      });
    });
  }



function initReviewSlideremersions() {
    const slider = document.querySelector('.u--real-emotions--slider');
    if (!slider) return;
    if (slider.classList.contains('swiper-initialized')) return;

    new Swiper(slider, {
      loop: false,
      centeredSlides: true,
      centeredSlidesBounds: true,
      navigation: {
        nextEl: '.u-real-emotions-slider-next',
        prevEl: '.u-real-emotions-slider-prev',
      },

      spaceBetween: 20,
      slidesPerView: 1.2,
      breakpoints: {
        0: {
          slidesPerView: 1.3,
        },
        415: {
          slidesPerView: 1.5,
        },
        768: {
          slidesPerView: 5.6,
        },
      },
    });
}
  
function initHearReviewsSwiper() {
  new Swiper('.u-hear-reviews-slide', {
    spaceBetween: 20,
    loop: true,
    centeredSlides: true,
    slidesPerView: 1.3,

    pagination: {
      el: ".u-hear-swiper-pagination",
      clickable: true,
    },

    breakpoints: {
      380: {
        slidesPerView: 2,
      },
      679: {
        slidesPerView: 4.4,
      }
    }
  });
}

document.addEventListener('DOMContentLoaded', () => {
  const buttons = document.querySelectorAll('.u-new-collapsible-toggle');

  buttons.forEach((button) => {
    button.addEventListener('click', () => {
      const item = button.closest('.u-new-collapsible-item');
      const content = item.querySelector('.u-new-collapsible-content');

      // Close all other items
      document.querySelectorAll('.u-new-collapsible-item.active').forEach(function(openItem){
        if(openItem !== item){
          openItem.classList.remove('active');
          openItem.querySelector('.u-new-collapsible-content').style.maxHeight = 0;
        }
      });

      item.classList.toggle('active');

      if (item.classList.contains('active')) {
        content.style.maxHeight = content.scrollHeight + 'px';
      } else {
        content.style.maxHeight = 0;
      }
    });
  });
});


